var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.377 35.162c-9.698 0-17.587-7.886-17.587-17.581s7.889-17.581 17.587-17.581c9.698 0 17.587 7.886 17.587 17.581s-7.889 17.581-17.587 17.581zM30.377 3.196c-7.933 0-14.389 6.454-14.389 14.384s6.456 14.384 14.389 14.384c7.933 0 14.39-6.454 14.39-14.384s-6.456-14.384-14.389-14.384z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.247 60.8c-6.271 0-11.353-5.082-11.353-11.348s5.082-11.348 11.353-11.348c6.271 0 11.353 5.082 11.353 11.348s-5.082 11.348-11.353 11.348zM46.247 64c8.038 0 14.553-6.513 14.553-14.548s-6.516-14.548-14.553-14.548c-8.037 0-14.553 6.513-14.553 14.548s6.516 14.548 14.553 14.548z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.271 56.646c-0.883 0-1.6-0.717-1.6-1.6v-11.626c0-0.883 0.717-1.6 1.6-1.6s1.6 0.717 1.6 1.6v11.626c0 0.883-0.717 1.6-1.6 1.6z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.856 49.233c0-0.883 0.716-1.6 1.6-1.6h11.63c0.884 0 1.6 0.717 1.6 1.6s-0.716 1.6-1.6 1.6h-11.63c-0.884 0-1.6-0.717-1.6-1.6z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.296 60.734h-27.5c-0.959 0-1.599-0.639-1.599-1.598 0 0 0-4.475 3.517-8.631 4.157-5.754 12.471-8.95 23.343-8.95 0.64-0.959 1.279-2.237 1.919-3.197-0.32 0-0.959 0-1.599 0-6.715 0-12.471 0.959-17.267 3.197-3.837 1.598-7.035 4.156-9.273 7.033-3.837 5.114-3.837 10.229-3.837 10.548 0 2.557 2.238 4.795 4.796 4.795h31.017c-1.279-0.959-2.558-1.918-3.517-3.197z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInscription);
export default __webpack_public_path__ + "static/media/inscription.e83093f1acc42edf39af5d465f6da22d.svg";
export { ForwardRef as ReactComponent };